import React from 'react';

import * as C from './CommonCards.styles';
import * as S from './ProjectCards.styles';

type MimicReportCardsProps = {
  numCards: number;
};

export const MimicProjectCards = ({numCards}: MimicReportCardsProps) => {
  const mimickedProjectCards = (
    <>
      {Array(numCards)
        .fill({})
        .map((_, index) => {
          return (
            <C.SkeletonCard key={index}>
              <S.SkeletonTextWrapper>
                <C.SkeletonText />
                <C.SkeletonText />
              </S.SkeletonTextWrapper>
              <S.CardMeta>
                <S.UpdatedAtIcon />
                <C.SkeletonText width={100} />
                <S.RunsIcon /> <C.SkeletonText width={100} />
              </S.CardMeta>
            </C.SkeletonCard>
          );
        })}
    </>
  );
  return <C.Grid numColumns={numCards}>{mimickedProjectCards}</C.Grid>;
};
